// import {} from '@fortawesome/pro-regular-svg-icons'
import { faClock, faEye } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionIcon, Group, Tooltip } from '@mantine/core'
import React, { ReactElement } from 'react'

import CronEditor from '../../../1stlog-ui/src/components/CronEditor'
import Link from '../../../1stlog-ui/src/components/Link'
// import { useRouter } from '../../../1stlog-ui/src/components/Router'

type OptionsProps = {
  cronOrdersEnabled: boolean
  order: any
  setLoading: (loading: boolean) => void
  openLink: string
  routerProps: any
}

export const Options = (props: OptionsProps): ReactElement => {
  const { cronOrdersEnabled, order, setLoading, openLink, routerProps } = props

  return (
    <>
      <Group spacing="xs" noWrap>
        <Link to={openLink}>
          <Tooltip label={i18n.t('show_capfirst', 'Anzeigen')} withinPortal>
            <ActionIcon
              onClick={() => {
                // props.history.push(
                //   `/${orderHref}/${lodash.get(props, 'cellData')}`,
                // )
              }}
              variant="light"
              color="blue"
              size="xl"
            >
              <FontAwesomeIcon icon={faEye} />
            </ActionIcon>
          </Tooltip>
        </Link>

        {cronOrdersEnabled && (
          <CronEditor
            {...routerProps}
            order={order}
            setLoading={setLoading}
            buttonElement={({ onClick }) => (
              <Tooltip
                label={i18n.t('cron_editor_order', 'Dauerauftrag erstellen')}
                withinPortal
              >
                <ActionIcon
                  onClick={onClick}
                  variant="light"
                  color="blue"
                  size="xl"
                >
                  <FontAwesomeIcon icon={faClock} />
                </ActionIcon>
              </Tooltip>
            )}
          />
        )}
      </Group>
    </>
  )
}
